import { Permission, notEqual } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { PayItemConnectionGroup, useGroupsContext } from '../../GroupsContext'
import { CreateEditBodyValues } from '../../components/CreateEditBody/types'
import CreateEditBody from '../../components/CreateEditBody'
import { useEditPayItemConnectionGroupMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'

export function useEdit(): EditRowActionOptions<
  PayItemConnectionGroup,
  CreateEditBodyValues
> {
  const { toConnectionValues, fromConnectionValues, refetch } =
    useGroupsContext()
  const [edit] = useEditPayItemConnectionGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editPayItemConnectionGroup: {
        payItemConnectionGroup: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditPayItemConnectionGroup,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditBody />,
      initialValues: ({
        name,
        description,
        connections,
        internalConnections,
      }) => ({
        name,
        description,
        payItemConnections: toConnectionValues({
          connections,
          internalIds: internalConnections.map(
            ({ internalConnectionId }) => internalConnectionId
          ),
        }),
      }),
      onOk: async (
        {
          id,
          connections,
          name: currentName,
          description: currentDescription,
          internalConnections,
        },
        { name, payItemConnections, description }
      ) => {
        const { connectionIds, internalConnectionIds } =
          fromConnectionValues(payItemConnections)
        if (
          notEqual(
            connections.map(({ id }) => id),
            connectionIds
          ) ||
          currentName !== name ||
          currentDescription !== description ||
          notEqual(
            internalConnections.map(
              ({ internalConnectionId }) => internalConnectionId
            ),
            internalConnectionIds
          )
        ) {
          await edit({
            variables: {
              input: {
                id,
                connectionIds,
                description,
                internalConnectionIds,
                name,
              },
            },
          })
          refetch()
        }
      },
    },
  }
}
